module.exports = __webpack_public_path__ + "static/media/Buzz9.29ae8c10.jpg";